module.exports = __webpack_public_path__ + "static/img/m_home_advantage_safe@3x.5f43800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_home_advantage_safe@3x.png
// module id = m+1I
// module chunks = 1